import { BetState } from '../../../states/entities/bets';
import { EntitiesOutcomes } from '../../../states/entities/outcomes';
import { specifiersToHash } from '../../../utils/bet';

export const getBetSliderValue = (bet: BetState, specifier: string): string => {
  const specifiers = specifiersToHash(bet?.specialBetValue);
  return specifiers?.[specifier];
};

export const getAllUniqueSliderValues = (
  matchBets: Array<{
    bet: BetState;
    isMultichoice: boolean;
  }>,
  specifier: string,
  outcomes: EntitiesOutcomes,
) => {
  const allValues = matchBets
    .map((matchBet) => matchBet.bet)
    .reduce<Record<string, { value: string; label: string }>>((acc, bet) => {
      const specifiers = specifiersToHash(bet?.specialBetValue);
      if (specifiers?.[specifier]) {
        acc[specifiers?.[specifier]] = {
          value: specifiers?.[specifier],
          label: bet.outcomes.length ? outcomes[bet.outcomes[0]]?.label : '',
        };
      }
      return acc;
    }, {});
  return Object.keys(allValues)
    .map((key) => allValues[key])
    .sort((a, b) => Number(a.value) - Number(b.value));
};
